// src/components/PlanCard.js
import React from 'react';

const PlanCard = ({
  logoTop,
  logoLeft,
  planName,
  itens,
  preco,
  onDetalhesClick,
  onSimularClick,
}) => {

  // --- Lógica de Estilo do Plano ---
  const baseClasses = "text-sm px-2 py-1 rounded-lg text-center mb-4 font-semibold";

  const getPlanStyling = (name) => {
    // A cor do texto é a mesma para todos (`text-gray-800`)
    if (name === 'Plano Nacional') {
      // Estilo para o Plano Nacional: fundo azul claro, texto cinza escuro.
      return `${baseClasses} bg-blue-100 text-gray-800`;
    }
    if (name === 'Plano Regional') {
      // Estilo para o Plano Regional: fundo verde claro, texto cinza escuro.
      return `${baseClasses} bg-green-100 text-gray-800`;
    }
    // Estilo padrão para qualquer outro plano.
    return `${baseClasses} bg-gray-100 text-gray-800`;
  };

  return (
    <div className="flex-shrink-0 w-[300px] bg-white shadow-lg rounded-lg p-4 flex flex-col h-full">
      <img src={logoTop} alt="Logo Topo" className="w-[100px] mx-auto mb-4" />

      <div className="flex justify-center mb-4">
        <img src={logoLeft} alt="Logo Esquerda" className="w-[100px]" />
      </div>

      <p className={getPlanStyling(planName)}>
        {planName || "Nome do Plano Indisponível"}
      </p>

      <div className="flex flex-col flex-grow justify-between">
        <ul className="text-left mb-4 space-y-1">
          {itens.map((item, i) => (
            <li key={i} className="text-sm text-gray-700">• {item}</li>
          ))}
        </ul>
        <div className="text-center text-lg font-bold text-black mb-4">{preco}/mês</div>
      </div>

      <div className="space-y-2 mt-auto">
        {/* --- BOTÃO "MAIS DETALHES" ATUALIZADO --- */}
        <button
          onClick={onDetalhesClick}
          className="w-full h-12 bg-[#2A4DD0] text-white text-sm font-bold rounded-md hover:bg-[#2441B5] transition"
        >
          Mais detalhes
        </button>
        <button
          onClick={onSimularClick}
          className="w-full h-12 text-sm font-bold rounded-md transition border border-[#2A4DD0] text-[#2A4DD0] bg-white hover:bg-[#F0F4FF]"
        >
          Simular
        </button>
      </div>
    </div>
  );
};

export default PlanCard;